import * as forgot from '../actions/forgot-password';
import { ForgotPasswordForm } from '../models/forgot-password';

export interface State {
  code: string;
  emailLinkSuccess: boolean;
  error: string;
  form: ForgotPasswordForm;
  pending: boolean;
  success: boolean;
}

export const initialState: State = {
  error: null,
  pending: false,
  form: {email: ''},
  code: null,
  success: null,
  emailLinkSuccess: null,
};

export function reducer(state = initialState, action: forgot.Actions): State {
  switch (action.type) {

    case forgot.FORGOT_PASSWORD: {
      return {
        ...state,
        pending: true,
        error: null,
        form: action.payload,
      };
    }
    case forgot.FORGOT_PASSWORD_REDIRECT_SUCCESS: {
      return {
        ...state,
      };
    }
    case forgot.FORGOT_PASSWORD_SEND_EMAIL_LINK_SUCCESS: {
      return {
        ...state,
        emailLinkSuccess: true,
        pending: false,
      };
    }
    case forgot.FORGOT_PASSWORD_SEND_EMAIL_LINK: {
      return {
        ...state,
        pending: true,
      };
    }
    case forgot.FORGOT_PASSWORD_SEND_EMAIL_LINK_FAILURE: {
      return {
        ...state,
        emailLinkSuccess: false,
        pending: false,
      };
    }
    case forgot.FORGOT_PASSWORD_REDIRECT_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case forgot.FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        error: null,
        pending: false,
        success: true,
      };
    }

    case forgot.FORGOT_PASSWORD_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
        success: false,
      };
    }

    case forgot.FORGOT_PASSWORD_RESET: {
      return initialState;
    }


    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getForm = (state: State) => state.form;
export const getCode = (state: State) => state.code;
export const getSuccess = (state: State) => state.success;
export const getEmailLinkSuccess = (state: State) => state.emailLinkSuccess;



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/reducers/forgot-password.ts